<!--
  ~ Copyright (c) 2025. Slimme Infrasoftware B.V. Apeldoorn /
  ~ Spin in het Web B.V. Apeldoorn.
  ~ Deze software mag alleen gebruikt / bekeken / gewijzigd worden
  ~ volgens de voorwaarden die zijn vastgelegd in de overeenkomst
  ~ tussen ATR en Slimme Infrasoftware B.V. en de onderliggende
  ~ overeenkomsten tussen Slimme Infrasoftware B.V en
  ~ Spin in het Web B.V.
  -->

<div class="regel-editor regel-project">
  <div class="regel-header d-flex align-items-center justify-content-between mb-2">
    <div class="d-flex align-items-center">
      <span class="badge badge-primary mr-2">{{ regelTypeNamen[regel.context].label }}</span>
      <span class="badge badge-warning mr-2" title="Deze editor is nog in ontwikkeling">Nog in ontwikkeling</span>
      @if (!isRegelGeldig) {
        <span class="fas fa-exclamation-triangle text-warning" title="Deze regel is ongeldig"></span>
      }
    </div>
    <filterregel-acties
      [clausuleId]="clausuleId!"
      [isInRootGroep]="isInRootGroep"
      (uitDezeGroep)="uitDezeGroep.emit($event)"
      (wikkelInEn)="wikkelInEn.emit($event)"
      (wikkelInOf)="wikkelInOf.emit($event)"
      (verwijder)="verwijder.emit($event)"></filterregel-acties>
  </div>

  <div class="regel-body">
    <input type="text" class="form-control d-inline-block w-auto"
           [id]="id('naam')" [value]="regel?.naam || ''"
           (input)="onNaamInput($any($event.target).value)"/>
  </div>
</div>
